export { default } from './BlogItemMini'
